export const translations = {
  logo: {
    en: "Logo",
    es: "Logo",
  },
  claim: {
    en: "claim",
    es: "RECLAMAR",
  },
  bloodstone: {
    en: "Viltrumita",
    es: "Viltrumita",
  },
  summonBeast: {
    en: "Summon Spaceship",
    es: "Invocar nave",
  },
  summonQuantity: {
    en: "Summon Quantity",
    es: "Cantidad de invocación",
  },
  currentBeasts: {
    en: "Current spaceship",
    es: "spaceship actuales",
  },
  warriorCapacity: {
    en: "Total Capacity of All spaceship",
    es: "Capacidad máxima total de guerreros",
  },
  filterCapacity: {
    en: "Filter By Capacity",
    es: "Filtrar por capacidad",
  },
  all: {
    en: "All",
    es: "Todo",
  },
  welcome: {
    en: "AzazelIV is watching",
    es: "AzazelIV está mirando",
  },
  play: {
    en: "Command Base (Space X)",
    es: "Base Comando (Space X)",
  },
  market: {
    en: "Marketplace",
    es: "Mercado",
  },
  getBloodstone: {
    en: "Get $Viltrumita",
    es: "Consigue $$Viltrumita",
  },
  howToPlay: {
    en: "How To Play",
    es: "Cómo jugar",
  },
  social: {
    en: "Social",
    es: "Social",
  },
  privacy: {
    en: "Privacy",
    es: "Intimidad",
  },
  beasts: {
    en: "Spaceship",
    es: "Naves",
  },
  warriors: {
    en: "Warriors",
    es: "guerreros",
  },
  legions: {
    en: "Legions",
    es: "legiones",
  },
  hunt: {
    en: "invade planets",
    es: "invadir planetas",
  },
  usefulLinks: {
    en: "LINKS AND SOCIAL NETWORKS",
    es: "ENLACES Y REDES SOCIALES",
  },
  buyViltrumita: {
    en: "Buy $VLT",
    es: "Comprar $VLT",
  },
  help: {
    en: "Help",
    es: "Ayudar",
  },
  pancakeswap: {
    en: "Pancakeswap",
    es: "Pancakeswap",
  },
  whitepaper: {
    en: "Whitepaper",
    es: "Papel blanco",
  },
  twitter: {
    en: "Twitter",
    es: "Gorjeo",
  },
  telegram: {
    en: "Telegram",
    es: "Telegrama",
  },
  discord: {
    en: "Discord",
    es: "Discordia",
  },
  policy: {
    en: "Policy",
    es: "Política",
  },
  madeWith: {
    en: "Made with",
    es: "Hecho con",
  },
  cryptoAgency: {
    en: "by Cryptomine Space X, company",
    es: "by Cryptomine Space X, company",
  },
  createLegion: {
    en: "Create Legion",
    es: "crear legión",
  },
  loadingBeasts: {
    en: "Loading...",
    es: "Cargando...",
  },
  summonWarrior: {
    en: "Summon Warriors",
    es: "Invocar guerrero",
  },
  currentWarriors: {
    en: "Current Warriors",
    es: "Guerreros actuales",
  },
  attackPower: {
    en: "Total Attack Power",
    es: "Poder de ataque total",
  },
  loadingWarriors: {
    en: "Loading Warriors ...",
    es: "Cargando guerreros ...",
  },
  nameLegion: {
    en: "Name Your Legion",
    es: "Nombra tu legión",
  },
  loadingTitle: {
    en: "Loading Warriors & Spaceship...",
    es: "Cargando Guerreros y Bestias...",
  },
  createLegionsBtn: {
    en: "Create legion with ",
    es: "Crea legión con ",
  },
  btnBackToLegions: {
    en: "Back to your Legions",
    es: "Crea legión con",
  },
  updateLegion: {
    en: "Update Legion",
    es: "Actualizar Legión",
  },
  updateNamePlaceholder: {
    en: "Name of the legion that is being updated",
    es: "Nombre de la legión que se está actualizando",
  },
  yourOldLegionAP: {
    en: "Your existing legion has ",
    es: "Su legión existente tiene ",
  },
  dragAndDropInst: {
    en: "Drag/Drop Spaceships/warriors",
    es: "Arrastrar/soltar naves/guerreros",
  },
  availableWarrior: {
    en: "Available Warriors",
    es: "Guerreros disponibles",
  },
  availableBeast: {
    en: "Available Spaceship",
    es: "Bestias disponibles",
  },
  currentLegion: {
    en: "Current Legions",
    es: "Legiones actuales",
  },
  totalAp: {
    en: "Total AP",
    es: "AP totales",
  },
  top3Legions: {
    en: "Top 3 Legions",
    es: "Las 3 mejores legiones",
  },
  lowest: {
    en: "Lowest",
    es: "más bajo",
  },
  highest: {
    en: "Highest",
    es: "más alto",
  },
  sortByAp: {
    en: "Sort By AP",
    es: "Ordenar por AP",
  },
  filterByAp: {
    en: "Filter By AP",
    es: "Filtrar por AP",
  },
  huntStatus: {
    en: "Invasion Status",
    es: "Estado de la invasion",
  },
  green: {
    en: "Green",
    es: "Verde",
  },
  orange: {
    en: "Orange",
    es: "naranja",
  },
  red: {
    en: "Red",
    es: "rojo",
  },
  hideWeakLegions: {
    en: "Hide Weak Legions",
    es: "Ocultar legiones débiles",
  },
  buySupply: {
    en: "Buy Supplies",
    es: "Comprar más suministros",
  },
  filterLevel: {
    en: "Filter By Level",
    es: "Filtrar por nivel",
  },
  loadingMonsters: {
    en: "Loading planets...",
    es: "Cargando planetas...",
  },
  yourInventory: {
    en: "YOUR INVENTORY",
    es: "SU INVENTARIO",
  },
  availableLegions: {
    en: "Available legions to invade",
    es: "Available legions to invade",
  },
  waitingTimeToHunt: {
    en: "Waiting time until next invasion",
    es: "Tiempo de espera hasta la próxima invasion",
  },
  yourMaxAp: {
    en: "AP of top legion",
    es: "AP de la legión superior",
  },
  unClaimed: {
    en: "Unclaimed $VLT",
    es: "$VLT no reclamado",
  },
  claimTax: {
    en: "If you'd claim now, you'd pay",
    es: "Si reclamaras ahora, pagarías",
  },
  claimTaxVal: {
    en: "$VLT tax",
    es: "impuesto $VLT",
  },
  taxDaysLeft: {
    en: "Tax Days Left",
    es: "Días de impuestos restantes",
  },
  BLSTInYourWallet: {
    en: "$VLT in Your Wallet",
    es: "$VLT en su billetera",
  },
  takeAction: {
    en: "TAKE ACTION",
    es: "Tomar acción",
  },
  takeActionSummonBeastQuantity: {
    en: "SUMMON Spaceship QUANTITY",
    es: "Invocar cantidad de naves",
  },
  takeActionSummonWarriorQuantity: {
    en: "SUMMON WARRIOR QUANTITY",
    es: "Invocar cantidad de guerreros",
  },
  takeActionCreateLegion: {
    en: "CREATE LEGION",
    es: "Comprar Naves",
  },
  takeActionMassHunt: {
    en: "massive invasion of the planet",
    es: "invasion masiva al planeta",
  },
  takeActionBuyBeasts: {
    en: "spaceships Market",
    es: "Mercado de naves",
  },
  takeActionBuyWarriors: {
    en: "Warriors Market",
    es: "Mercado de guerreros",
  },
  takeActionBuyLegions: {
    en: "Legions Market",
    es: "Mercado de las legiones",
  },
  takeActionPoocoin: {
    en: "Poocoin Chart",
    es: "Gráfico de Poocoin",
  },
  takeActionBuyBlst: {
    en: "BUY $VLT",
    es: "COMPRAR $VLT",
  },
  yourAchievements: {
    en: "YOUR ACHIEVEMENTS",
    es: "Sus logros",
  },
  readInstructionsInWhitePaper: {
    en: "READ INSTRUCTIONS IN WHITEPAPER",
    es: "Lea las instrucciones en el documento técnico",
  },
  summonWarriorSuccessful: {
    en: "Summon Warriors successfully! If you see your all warriors, please click this!",
    es: "¡Invoca guerreros con éxito! Si ves a todos tus guerreros, ¡haz clic aquí!",
  },
  summonBeastSuccessful: {
    en: "Summon spaceships successfully! If you see your all spaceships, please click this!",
    es: "¡Invoca naves con éxito! Si ves todas tus naves, ¡haz clic aquí!",
  },
  summoningBeasts: {
    en: "Summoning spaceships...",
    es: "Naves de invocación...",
  },
  nadodoWatching: {
    en: "AzazelIV IS WATCHING",
    es: "AzazelIV está mirando",
  },
  summoningWarriors: {
    en: "Summoning Warriors...",
    es: "Invocando guerreros...",
  },
  marketplaceTax: {
    en: "Marketplace Tax",
    es: "Impuesto del Mercado",
  },
  huntTax: {
    en: "invasion taxes",
    es: "Impuestos por invasion planetaria",
  },
  buyTax: {
    en: "Buy Tax",
    es: "Comprar impuestos",
  },
  sellTax: {
    en: "Sell Tax",
    es: "Impuesto de venta",
  },
  legionDamagePerHunt: {
    en: "Legion Damage Per invasion",
    es: "Daño de legión por invasion",
  },
  summoningFee: {
    en: "Summoning Fee",
    es: "Cuota de convocatoria",
  },
  SuppliesFee14Hunts: {
    en: "Supplies Fee for 14 invasion",
    es: "Tarifa de suministros para 14 invasion",
  },
  SuppliesFee28Hunts: {
    en: "Supplies Fee for 28 invasion",
    es: "Tarifa de suministros para 28 invasion",
  },
  RewardPool: {
    en: "Reward Pool",
    es: "Grupo de recompensas",
  },
  ReservePool: {
    en: "Reserve Pool",
    es: "Grupo de reserva",
  },
  LiquidityPool: {
    en: "Liquidity Pool",
    es: "Fondo de liquidez",
  },
  buyingSupplies: {
    en: "Buying Supplies...",
    es: "Compra de suministros...",
  },
  loadingLegions: {
    en: "Loading Legions...",
    es: "Cargando Legiones...",
  },
  noMintedLegion: {
    en: "You need to create a legion or fleet first to start invading planets!",
    es: "¡Necesitas crear una flota primero para comenzar la invasion planetaria !.",
  },
  marketplace: {
    en: "Marketplace",
    es: "Mercado",
  },
  sortBy: {
    en: "Sort By",
    es: "Ordenar por",
  },
  confirm: {
    en: "Confirm",
    es: "Confirmar",
  },
  huntTime: {
    en: "Time to invade!",
    es: "llego la hora de invadir planetas!",
  },
  huntTimeSubtitle1: {
    en: "Your legion is now attacking the planets:",
    es: "Tu legión ahora está atacando al planets:",
  },
  congratulation: {
    en: "Congratulations!",
    es: "Felicidades!",
  },
  congSubtitle1: {
    en: "You have succeeded in invading this planet!",
    es: "¡Has logrado invadir este planeta!",
  },
  congSubtitle3: {
    en: "To win you need to roll equal or less than:",
    es: "Para ganar necesitas tirar igual o menos que:",
  },
  continue: {
    en: "Continue",
    es: "Continuar",
  },
  defeatTitle: {
    en: "Better Luck Next Time...",
    es: "Mejor suerte la próxima vez...",
  },
  defeatSubtitle1: {
    en: "Your legion failed to invade this planet.",
    es: "Tu legión no logró invadir este planeta. Prueba otra vez.!",
  },
  defeatSubtitle2: {
    en: "To win you need to roll equal or less than:",
    es: "Para ganar necesitas tirar igual o menos que:",
  },
  yourRollTitle: {
    en: "Your roll is",
    es: "tu rollo es",
  },
  showMyWarrior: {
    en: "Show Only My Warriors",
    es: "Mostrar solo mis guerreros",
  },
  pleaseWait: {
    en: "Please Wait...",
    es: "Espere por favor...",
  },
  first: {
    en: "First",
    es: "Primero",
  },
  last: {
    en: "Last",
    es: "Último",
  },
  previous: {
    en: "Previous",
    es: "Anterior",
  },
  next: {
    en: "Next",
    es: "Próximo",
  },
  showMyBeast: {
    en: "Show Only My Spaceship",
    es: "Mostrar solo mis bestias",
  },
  showMyLegion: {
    en: "Show Only My Legions",
    es: "Mostrar solo mis legiones",
  },
  filterByHunts: {
    en: "Filter by remaining scans",
    es: "Filtrar por exploraciones restantes",
  },
  listOnMarketplace: {
    en: "List On Marketplace",
    es: "Lista al mercado",
  },
  congSubtitle2: {
    en: "You have been rewarded",
    es: "has sido recompensado",
  },
  warriorMaster: {
    en: "Warrior Master",
    es: "Maestro guerrero",
  },
  beastMaster: {
    en: "Spaceship Master",
    es: "Maestro de bestias",
  },
  legionMaster: {
    en: "Legion Master",
    es: "Maestro de la legión",
  },
  monsterConqueror: {
    en: "Planet Conqueror",
    es: "Conquistador de Planetas",
  },
  "King/Queen": {
    en: "Emperor of the known universe.!",
    es: "Emperador del universo conocido.!",
  },
  warriorMasterEx: {
    en: "Own a level 6 warrior",
    es: "Ten un guerrero de nivel 6",
  },
  beastMasterEx: {
    en: "Own a Spaceship with 20 capacity",
    es: "Posee una bestia con 20 de capacidad.",
  },
  legionMasterEx: {
    en: "Own 10 legions of 30,000+ AP",
    es: "Posee 10 legiones de 30,000+ AP",
  },
  monsterConquerorEx: {
    en: "Win an invasion of planet 23",
    es: "Gana una invasion de planeta 23",
  },
  "King/QueenEx": {
    en: "Win an invasion of planet 24",
    es: "Gana una invasion de planeta 24",
  },
  sell: {
    en: "Sell",
    es: "Vender",
  },
  noBeastFilter: {
    en: "No Spaceships with this capacity. Summon some more!",
    es: "No hay bestias con esta capacidad. ¡Convoca a algunos más!",
  },
  noWarriorFilter: {
    en: "No warriors with this level/AP. Summon some more!",
    es: "No hay guerreros con este nivel/AP. ¡Convoca a algunos más!",
  },
  LongFeeToolTip: {
    en: "Fee to create your legion is ",
    es: "La tarifa para crear tu legión es",
  },
  ShortFeeToolTip: {
    en: "Fee",
    es: "Tarifa",
  },
  feeToUpdate: {
    en: "Fee to update ",
    es: "Tarifa para actualizar ",
  },
  to: {
    en: "to",
    es: "para",
  },
  create: {
    en: "Create",
    es: "Crear",
  },
  notEnoughBeasts: {
    en: "Not enough Spaceships",
    es: "No hay suficientes bestias",
  },
  min: {
    en: "min",
    es: "min",
  },
  needed: {
    en: "needed",
    es: "necesario",
  },
  existingAPIs: {
    en: "Existing AP is",
    es: "El AP existente es",
  },
  update: {
    en: "Update",
    es: "Actualizar",
  },
  base: {
    en: "Base",
    es: "Base",
  },
  bonus: {
    en: "Bonus",
    es: "Prima",
  },
  toWin: {
    en: "to Win",
    es: "ganar",
  },
  huntTransactionFailed: {
    en: "Transaction is failed, please try again!",
    es: "",
  },
};
